import React from "react";
import { Button } from "semantic-ui-react";
import "./cmp-session-timeout.css";

export default function CMP_SESSION_TIMEOUT({
  set_mdl_open,
  var_modaltitle,
  var_message,
  confirmation_function,
}) {
  /* VARIABLE DECLARATIONS
    ---------------------------------------------------------------------------------*/

  /* EVENT LISTENERS
    ---------------------------------------------------------------------------------*/

  /* EVENT FUNCTIONS
    ---------------------------------------------------------------------------------*/
  function onClick() {
    confirmation_function();
    set_mdl_open(false);
  }

  /* RENDER APP
    ---------------------------------------------------------------------------------*/
  return (
    <>
      <div className="session-modal-header">
        <div
          style={{
            fontSize: "18px",
            fontWeight: "600",
          }}
        >
          {var_modaltitle}
        </div>
      </div>
      <div className="session-modal-content">
        <img
          src="/session-timeout.svg"
          alt="Session Timeout"
          style={{
            width: "80px",
            height: "80px",
            marginBottom: "12px",
          }}
        />
        <p className="confirmation_message">{var_message}</p>
      </div>

      <div className="modal-footer" style={{ justifyContent: "center" }}>
        <Button type="button" color="red" onClick={() => onClick()}>
          Login
        </Button>
      </div>
    </>
  );
}
